angular
    .module('empower.memberBenefit', [])
    .config(['$routeProvider', function ($routeProvider) {
        $routeProvider
           .when('/member-benefits', {
               templateUrl: 'module/memberBenefit/view/member-benefit.html',
               controller: 'memberBenefitController'
           });
    }]);
